export const bigcommerce = {
  tokenHelp:
    'Der Token ist zu finden unter "Einstellungen > Store-level API account"'
};
